import search from '@/services/api/search';

import { getField, updateField } from 'vuex-map-fields';

const defaultFlter = () => {
    return {
        searchInput: null,
        provinces: [],
        locations: [],
        volunteers: [],
        permissions_for_contact: [],
        storages: [],
        help_criteria: [],
        status: [],
        advanced_status: [],
        recommendations_for_package_plus: [],
        past_edition_participation_amounts: [],
        user_volunteered: false,
        support_criteria: [],
        sorting: {
            address: null,
            last_name: null
        }
    };
};

export default {
    namespaced: true,
    state: {
        filter: defaultFlter(),
        prevFilter: {},
        qualifiedSuggestResult: [],
        searchSuggestLoader: false,
        filterResources: null,
        regionsInProvinces: {},
        selectedRegionsId: [],
        volunteersInRegions: {},
        selectedVolunteersId: [],
        regionsPerProvince: []
    },
    getters: {
        getField,
        getFilter: (state) => state.filter,
        getPrevFilter: (state) => state.prevFilter,
        getQualifiedSuggestResult: (state) => state.qualifiedSuggestResult,
        getSearchSuggestLoader: (state) => state.searchSuggestLoader,
        getFilterResources: (state) => state.filterResources,
        getRegionsInProvinces: (state) => state.regionsInProvinces,
        getVolunteersInRegions: (state) => state.volunteersInRegions,
        getRegionsPerProvince: (state) => state.regionsPerProvince
    },
    mutations: {
        updateField,
        clearFilter (state) {
            state.filter = defaultFlter();
            state.prevFilter = {};
            state.regionsInProvinces = {};
            state.selectedRegionsId = [];
            state.volunteersInRegions = {};
            state.selectedVolunteersId = [];
            state.qualifiedSuggestResult = [];
        },
        setQualifiedSuggestResult (state, data) {
            state.qualifiedSuggestResult = data;
        },
        setSearchSuggestLoader (state, data) {
            state.searchSuggestLoader = data;
        },
        setFilterResources (state, data) {
            state.filterResources = data;
        },
        setRegion (state, data) {
            const array = [];
            data.data.forEach((item) => {
                for (const [key, value] of Object.entries(item)) {
                    array.push({
                        value: key,
                        description: value
                    });
                }
            });
            state.regionsInProvinces[data.id] = array;
        },
        setVolunteers (state, data) {
            const array = [];
            data.data.forEach((item) => {
                array.push({
                    value: item.account_id,
                    description: item.full_name
                });
            });
            state.volunteersInRegions[data.id] = array;
        },
        setRegionsPerProvince (state, data) {
            state.regionsPerProvince = data;
        },
        setSorting (state, data) {
            state.filter.sorting[data.key] = data.value;
        },
        setPrevFilter (state, data) {
            state.prevFilter = data;
        }
    },
    actions: {
        async getFilterResources ({ commit }, payload) {
            if (search?.filtersResources) {
                try {
                    const { data } = await search.filtersResources(payload);
                    if (data?.data) {
                        commit('setFilterResources', data.data);
                        return data.data;
                    }
                } catch (error) {
                    return null;
                }
            }
            return null;
        },
        searchSuggest (context, payload) {
            const query = new URLSearchParams();
            const { searchInput, isQualified } = payload;
            query.append('query', searchInput);

            const data = {
                params: {},
                queryString: query
            };

            context.commit('setQualifiedSuggestResult', []);
            context.commit('setSearchSuggestLoader', true);
            return search
                .searchSuggest(data, isQualified)
                .then(({ data }) => {
                    let array = Object.entries(data.data);
                    let amount = 0;
                    array = array.filter((el) => {
                        return el && el[1] && el[1].amount > 0;
                    });
                    array.forEach((el) => {
                        amount += el[1].amount;
                    });
                    context.commit('setQualifiedSuggestResult', array);
                    return {
                        query: searchInput,
                        amount
                    };
                })
                .finally(() => {
                    context.commit('setSearchSuggestLoader', false);
                });
        },
        async getVolunteersByRegion (context, payload) {
            for (const el of payload) {
                if (context.state.selectedVolunteersId.some((x) => x === el)) {
                    continue;
                }
                context.state.selectedVolunteersId.push(el);
                await search
                    .getVolunteersPerRegion(el)
                    .then(({ data }) => {
                        context.commit('setVolunteers', {
                            id: el,
                            data: data.data
                        });
                    })
                    .catch(() => {
                        const index = context.state.selectedVolunteersId.indexOf(el);
                        if (index !== -1) {
                            context.state.selectedVolunteersId.splice(index, 1);
                        }
                    });
            }
            return context.getters.getVolunteersInRegions;
        },
        getRegionsPerProvince (context, payload) {
            return search.getRegionsPerProvince(payload).then((data) => {
                const _res = data.data.data;
                const _arr = [];
                _res.forEach((el) => {
                    Object.keys(el).forEach((key) => {
                        const _obj = {
                            value: key,
                            description: el[key]
                        };
                        _arr.push(_obj);
                    });
                });
                context.commit('setRegionsPerProvince', _arr);
            });
        }
    }
};
